/* MACLINS - Pedido minimo de atacado (15 pecas ou 1 box) */
(function () {
  var MIN = 15;
  var state = { count: null, hasBox: false };
  var observer = null;
  var debTimer = null;

  function injectStyleOnce() {
    if (document.getElementById('maclins-min-style')) return;
    var s = document.createElement('style');
    s.id = 'maclins-min-style';
    s.textContent =
      '.maclins-min-notice{display:none;width:100%;flex-basis:100%;grid-column:1 / -1;box-sizing:border-box;' +
      'margin:0 0 12px;padding:12px 14px;border:2px solid #F7931E;background:#fff6ec;color:#111;' +
      'border-radius:8px;font-size:14px;line-height:1.35;font-weight:600;text-align:left;}' +
      '.maclins-min-notice small{display:block;font-weight:400;color:#555;margin-top:2px;}' +
      'button[name="checkout"][disabled],.maclins-disabled{opacity:.5;cursor:not-allowed !important;}';
    document.head.appendChild(s);
  }

  function isBoxItem(item) {
    var haystack = [
      item.handle,
      item.product_type,
      item.product_title,
      item.title,
      item.variant_title,
      item.sku
    ].filter(Boolean).join(' ').toLowerCase();
    return /(^|[^a-z0-9])box([^a-z0-9]|$)/i.test(haystack) || haystack.indexOf('box_maclins') > -1;
  }

  function noticeHtml(count) {
    var falta = MIN - count;
    return 'Pedido m\u00ednimo no atacado: ' + MIN + ' pe\u00e7as ou 1 box.' +
      '<small>Voc\u00ea tem ' + count + ' pe\u00e7a' + (count === 1 ? '' : 's') + ' avulsa' + (count === 1 ? '' : 's') +
      '; falta' + (falta === 1 ? '' : 'm') + ' ' + falta +
      ' para liberar a finaliza\u00e7\u00e3o. Comprando um box, o pedido j\u00e1 fica liberado.</small>';
  }

  function noticeFor(btn) {
    var cta = btn.closest('.cart__ctas');
    var container, anchor;
    if (cta && cta.parentElement) { container = cta.parentElement; anchor = cta; }
    else { container = btn.parentElement; anchor = btn; }
    if (!container) return null;
    var n = container.querySelector(':scope > .maclins-min-notice');
    if (!n) {
      n = document.createElement('div');
      n.className = 'maclins-min-notice';
      container.insertBefore(n, anchor);
    }
    return n;
  }

  function hideNoticeNear(btn) {
    var cta = btn.closest('.cart__ctas');
    var container = (cta && cta.parentElement) ? cta.parentElement : btn.parentElement;
    var n = container && container.querySelector(':scope > .maclins-min-notice');
    if (n) n.style.display = 'none';
  }

  function isBelowMinimum() {
    return state.count !== null && state.count < MIN && !state.hasBox;
  }

  function apply() {
    if (state.count === null) return;
    var below = isBelowMinimum();

    document.querySelectorAll('button[name="checkout"], #checkout').forEach(function (btn) {
      if (below) {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('maclins-disabled');
        var n = noticeFor(btn);
        if (n) { n.innerHTML = noticeHtml(state.count); n.style.display = 'block'; }
      } else {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('maclins-disabled');
        hideNoticeNear(btn);
      }
    });

    document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons').forEach(function (el) {
      el.style.display = below ? 'none' : '';
    });

    document.querySelectorAll('.shopify-payment-button').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  function applySafe() {
    if (observer) observer.disconnect();
    try { apply(); } finally {
      if (observer) observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        state.count = cart.item_count || 0;
        state.hasBox = items.some(isBoxItem);
        applySafe();
      })
      .catch(function () {});
  }

  function scheduleRefresh() {
    clearTimeout(debTimer);
    debTimer = setTimeout(refresh, 200);
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.querySelector && f.querySelector('button[name="checkout"], #checkout')) {
      if (isBelowMinimum()) {
        e.preventDefault(); e.stopImmediatePropagation();
        alert('Pedido m\u00ednimo no atacado: ' + MIN + ' pe\u00e7as ou 1 box. Voc\u00ea tem ' + state.count + ' pe\u00e7a' + (state.count === 1 ? '' : 's') + '.');
        refresh();
      }
    }
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"], #checkout');
    if (btn && isBelowMinimum()) {
      e.preventDefault(); e.stopImmediatePropagation();
      alert('Pedido m\u00ednimo no atacado: ' + MIN + ' pe\u00e7as ou 1 box. Voc\u00ea tem ' + state.count + ' pe\u00e7a' + (state.count === 1 ? '' : 's') + '.');
    }
  }, true);

  function start() {
    injectStyleOnce();
    observer = new MutationObserver(scheduleRefresh);
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart:refresh', refresh);
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
